var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_3012",
    "data-name": "Groupe 3012",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238",
    "data-name": "Rectangle 238",
    width: 44,
    height: 44,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3011",
    "data-name": "Groupe 3011",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36651",
    "data-name": "Trac\\xE9 36651",
    d: "M4,16a4,4,0,1,1-4,4,4,4,0,0,1,4-4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36652",
    "data-name": "Trac\\xE9 36652",
    d: "M13,16a4,4,0,1,1-4,4,4,4,0,0,1,4-4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36653",
    "data-name": "Trac\\xE9 36653",
    d: "M22,16a4,4,0,1,1-4,4,4,4,0,0,1,4-4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36654",
    "data-name": "Trac\\xE9 36654",
    d: "M31,16a4,4,0,1,1-4,4,4,4,0,0,1,4-4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36655",
    "data-name": "Trac\\xE9 36655",
    d: "M40,16a4,4,0,1,1-4,4,4,4,0,0,1,4-4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36656",
    "data-name": "Trac\\xE9 36656",
    d: "M4,26a4,4,0,1,1-4,4,4,4,0,0,1,4-4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36657",
    "data-name": "Trac\\xE9 36657",
    d: "M13,26a4,4,0,1,1-4,4,4,4,0,0,1,4-4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36658",
    "data-name": "Trac\\xE9 36658",
    d: "M22,26a4,4,0,1,1-4,4,4,4,0,0,1,4-4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36659",
    "data-name": "Trac\\xE9 36659",
    d: "M31,26a4,4,0,1,1-4,4,4,4,0,0,1,4-4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36660",
    "data-name": "Trac\\xE9 36660",
    d: "M40,26a4,4,0,1,1-4,4,4,4,0,0,1,4-4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36661",
    "data-name": "Trac\\xE9 36661",
    d: "M4,36a4,4,0,1,1-4,4,4,4,0,0,1,4-4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36662",
    "data-name": "Trac\\xE9 36662",
    d: "M13,36a4,4,0,1,1-4,4,4,4,0,0,1,4-4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36663",
    "data-name": "Trac\\xE9 36663",
    d: "M22,36a4,4,0,1,1-4,4,4,4,0,0,1,4-4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36664",
    "data-name": "Trac\\xE9 36664",
    d: "M31,36a4,4,0,1,1-4,4,4,4,0,0,1,4-4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36665",
    "data-name": "Trac\\xE9 36665",
    d: "M40,36a4,4,0,1,1-4,4,4,4,0,0,1,4-4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36666",
    "data-name": "Trac\\xE9 36666",
    d: "M17.375,0a4,4,0,1,1-4,4,4,4,0,0,1,4-4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36667",
    "data-name": "Trac\\xE9 36667",
    d: "M26.375,0a4,4,0,1,1-4,4,4,4,0,0,1,4-4",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_271",
    "data-name": "Ligne 271",
    x2: 17,
    transform: "translate(13.375 9.5)",
    fill: "none",
    stroke: "#cea95a",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg17);
export default __webpack_public_path__ + "static/media/17.12ce5c6254b3359e3591ee91a9bac85a.svg";
export { ForwardRef as ReactComponent };